module.exports = __webpack_public_path__ + "static/media/home.bb87c6df.svg";